import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AppFacadeService } from '../../../services/app-facade.service';
import { DateFormatType } from '../../../enums/date-format-type.enum';
import { AppMediatorService } from '../../../services/app-mediator.service';
import { DialogContentType } from '../../../enums/dialog-type.enum';
import { TransactionData, TransactionResultEnum } from '../../../payment/models/paymentOutput';
import { TOKENIZE_CARD_TRANSACTION_TYPE } from '../../../constants/default.const';

@Component({
    standalone: false,
    selector: 'por-payment-success-dialog',
    templateUrl: './payment-success-dialog.component.html',
    styleUrls: ['./payment-success-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentSuccessDialogComponent {
    readonly appFacadeService = inject(AppFacadeService);
    readonly appMediatorService = inject(AppMediatorService);

    dialogContentType = DialogContentType;
    dialogMessage = '';
    dateFormat: DateFormatType = DateFormatType.StandardDateTime;
    transactionResultEnum = TransactionResultEnum;

    /**
     * A TokenizeCard transaction vaulted the card and captured nothing (AB#114949), so the
     * approved branch must not claim a payment was received. Keyed on TransactionTypeEnum
     * rather than on the amount: the tokenize sentinel means Amount_Processed can be non-zero
     * even though no money moved.
     * @param transactionData - POR-Pay transaction data for the completed transaction
     */
    isTokenizeCard(transactionData?: Partial<TransactionData>): boolean {
        return transactionData?.TransactionTypeEnum === TOKENIZE_CARD_TRANSACTION_TYPE;
    }
}
